var CallBackOptionSuccessView, CommonBaseView, SupportThanksForContactingTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../../../thanks_for_contacting.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

CallBackOptionSuccessView = (function(superClass) {
  extend(CallBackOptionSuccessView, superClass);

  function CallBackOptionSuccessView() {
    return CallBackOptionSuccessView.__super__.constructor.apply(this, arguments);
  }

  CallBackOptionSuccessView.prototype.template = SupportThanksForContactingTemplate;

  CallBackOptionSuccessView.prototype.render = function(params) {
    this.$el.empty();
    return this.$el.append(toHtml(this.template, this.toHash(params.waitTime, params.phone_number), this.I18nScope));
  };

  CallBackOptionSuccessView.prototype.toHash = function(waitTime, phone_number) {
    return {
      phoneCallReceivemsg: I18n.translate('js.modules.support.call_me_back_phone_call_receive_msg', {
        display_wait_time: waitTime
      }),
      weContactYouPhoneNumberMsg: I18n.translate('js.modules.support.we_will_call_you', {
        display_phone_number: phone_number
      }),
      isCallMeBackFlow: true,
      showCallBackThankYouMsg: true
    };
  };

  return CallBackOptionSuccessView;

})(CommonBaseView);

module.exports = CallBackOptionSuccessView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL2NvbW1vbi9jYWxsX21lX2JhY2tfc3VjY2Vzc192aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vY2FsbF9tZV9iYWNrX3N1Y2Nlc3Nfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw2RUFBQTtFQUFBOzs7QUFBQSxrQ0FBQSxHQUFxQyxPQUFBLENBQVEsaURBQVI7O0FBQ3JDLGNBQUEsR0FBaUIsT0FBQSxDQUFRLHFDQUFSOztBQUVYOzs7Ozs7O3NDQUNKLFFBQUEsR0FBVTs7c0NBRVYsTUFBQSxHQUFRLFNBQUMsTUFBRDtJQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsS0FBTCxDQUFBO1dBQ0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQVEsTUFBTSxDQUFDLFFBQWYsRUFBeUIsTUFBTSxDQUFDLFlBQWhDLENBQWxCLEVBQWlFLElBQUMsQ0FBQSxTQUFsRSxDQUFaO0VBRk07O3NDQUlSLE1BQUEsR0FBTyxTQUFDLFFBQUQsRUFBVyxZQUFYO1dBQ0w7TUFBQSxtQkFBQSxFQUFxQixJQUFJLENBQUMsU0FBTCxDQUFlLHdEQUFmLEVBQXlFO1FBQUMsaUJBQUEsRUFBbUIsUUFBcEI7T0FBekUsQ0FBckI7TUFDQSwwQkFBQSxFQUE0QixJQUFJLENBQUMsU0FBTCxDQUFlLHFDQUFmLEVBQXNEO1FBQUMsb0JBQUEsRUFBc0IsWUFBdkI7T0FBdEQsQ0FENUI7TUFFQSxnQkFBQSxFQUFrQixJQUZsQjtNQUdBLHVCQUFBLEVBQXlCLElBSHpCOztFQURLOzs7O0dBUCtCOztBQWF4QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
